
import Vue from "vue";
import Component from "vue-class-component";
import {Prop} from "vue-property-decorator";
import "../plugins/flatpickr";
import { Estonian } from "flatpickr/dist/l10n/et.js";
import moment from "moment";
import "moment-timezone";
import LabelOptional from "@/features/shared/components/LabelOptional.vue";
import CreateUUID from "@/guid";
import {cultureService, ls} from "@/CultureService";


@Component({
    components: {
        LabelOptional
    }
})
export default class DatePicker extends Vue {
    @Prop({default: () => []})
    errorMessages!: string[];

    @Prop({default: ls.Components_DatePicker_Placeholder_Date})
    placeholder!: string;

    @Prop({required: true})
    labelText!: string;

    @Prop({type: Boolean, default: false})
    labelOptional!: boolean ;

    @Prop({default: () => CreateUUID()})
    id!: string;

    @Prop()
    value!: Date | null;
    @Prop({default: false})
    disabled!: boolean;

    @Prop({default: false})
    enableTime!: boolean;

    @Prop({default: null})
    maxDate?: string | Date | null;

    @Prop({default: null})
    minDate?: string | Date | null;

    date: Date | null = null;

    datepickerConfig = {
        allowInput: true,
        altFormat: this.enableTime ? 'd.m.Y H:i' : 'd.m.Y',
        altInput: true,
        altInputClass: `form-control input ${this.id}`,
        altAriaDateFormat: this.enableTime ? 'd.m.Y H:i' : 'd.m.Y',
        enableTime: this.enableTime,
        maxDate: this.maxDate,
        minDate: this.minDate,
        // eslint-disable-next-line @typescript-eslint/camelcase
        time_24hr: true,
        locale: cultureService.currentCulture2Letter == "et" ? Estonian : "en",
        nextArrow: '<i class="fas fa-chevron-right color-primary"></i>',
        prevArrow: '<i class="fas fa-chevron-left color-primary"></i>',
    }

    created()
    {
        this.$watch(() => this.value, (value) => {
            if(this.getTime(this.date) !== this.getTime(this.value)) {
                this.date = value ? moment(value).toDate() : null;
            }
        }, {immediate: true});

        this.$watch(() => this.date, () => {
            this.$emit("input", this.date ? moment(this.date).toDate() : null);
        });
    }

    mounted() {
        this.addIdToAltInputAndDisableAutocomplete();
    }

    getTime(date: Date | null | undefined):number{
        if(!date){
            return 0;
        }
        return moment(date).toDate().getTime();
    }

    //Added ID to alternative input to associate label with visible input field. Necessary for accessibility also.
    addIdToAltInputAndDisableAutocomplete() {
        const altInput = document.getElementsByClassName(this.id)[0];
        if (altInput) {
            altInput.id = this.id;
            altInput.setAttribute("autocomplete", "off");
        }
    }

    get localTimezone(){
        const timezone = moment(new Date()).tz(moment.tz.guess()).format("(z)");
        return timezone.replace("+", "UTC +");
    }
}
